module.exports = __webpack_public_path__ + "static/img/background.8f1fe13.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/background.jpg
// module id = H7sP
// module chunks = 0